var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-simple-table',[_c('tbody',_vm._l((_vm.reasons),function(reason){return _c('tr',[_c('td',[_vm._v(_vm._s(reason))])])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }